import { ChangeDetectionStrategy, Component} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({

    selector: 'app-procesando-cotizacion',
    standalone: true,
    imports: [MatProgressSpinnerModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template:  `
    <section
      class="procesando-cotizacion"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <mat-spinner diameter="50"></mat-spinner>

      <h2>Generando cotización</h2>

      <p>
        El pdf se esta preparando. Por favor, espere.
      </p>
    </section>
  `,
    styles:
    [
        `
        .procesando-cotizacion {
            width: 320px;
            max-width: 90vw;
            padding: 30px 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 16px;
            text-align: center;
            box-sizing: border-box;
            background-color: #fff;
        }

        .procesando-cotizacion h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 600;
        }

        .procesando-cotizacion p {
            margin: 0;
            line-height: 1.5;
        }
        `,
    ],

})
export class ProcesandoCotizacionComponent {}